var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMxm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMxm0)",
    d: "M13.223 5.571H10.72l-5.578 9.776l1.26 2.224H17.54l1.316-2.224zM6.32 15l4.862-8.572h1.071l-4.277 7.715h4.916l.57.857zm3.133-1.714l3.559-6.41l4.85 8.414l-.54.997l-4.31-7.431l-2.425 4.43zm2.117 0l.429-.858l.428.858zm1.455-2.742l3.571 6.168H6.884l-.527-.855h8.671l-2.502-4.403z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMxm0",
    x1: 8.48,
    x2: 13.288,
    y1: 6.36,
    y2: 17.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18DBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AF2CF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxm);
export default __webpack_public_path__ + "static/media/mxm.3ce4561ee9f79f4ac1b2698ce0e45e43.svg";
export { ForwardRef as ReactComponent };